import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { CAPTAIN_PAGE_PERMISSIONS } from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';

import CaptainPageRouteView from './pages/CaptainPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantOverviewIndex from './assistants/overview/Index.vue';
import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantOrdersIndex from './assistants/orders/Index.vue';
import AssistantTrainIndex from './assistants/train/Index.vue';
import AssistantBrainIndex from './assistants/brain/Index.vue';
import AssistantBehaviorIndex from './assistants/behavior/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

const captainMeta = (...keys) => ({
  permissions: ['administrator', ...keys],
  featureFlag: FEATURE_FLAGS.CAPTAIN,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
});

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/overview'),
    component: AssistantOverviewIndex,
    name: 'captain_assistants_overview_index',
    meta: captainMeta('captain_overview'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'captain_assistants_responses_index',
    meta: captainMeta('captain_train'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'captain_assistants_documents_index',
    meta: captainMeta('captain_train'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'captain_tools_index',
    meta: {
      ...captainMeta('captain_tools'),
      featureFlag: FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
    },
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'captain_assistants_scenarios_index',
    meta: {
      ...captainMeta('captain_train'),
      featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
    },
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/train'),
    component: AssistantTrainIndex,
    name: 'captain_assistants_train_index',
    meta: captainMeta('captain_train'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/brain'),
    component: AssistantBrainIndex,
    name: 'captain_assistants_brain_index',
    meta: captainMeta('captain_train'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/behavior'),
    component: AssistantBehaviorIndex,
    name: 'captain_assistants_behavior_index',
    meta: captainMeta('captain_behavior'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'captain_assistants_playground_index',
    meta: captainMeta('captain_playground'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/orders'),
    component: AssistantOrdersIndex,
    name: 'captain_assistants_orders_index',
    meta: captainMeta('captain_orders'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'captain_assistants_inboxes_index',
    meta: captainMeta('captain_inboxes'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'captain_assistants_responses_pending',
    meta: captainMeta('captain_train'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'captain_assistants_settings_index',
    meta: captainMeta('captain_settings'),
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'captain_assistants_guardrails_index',
    meta: {
      ...captainMeta('captain_settings'),
      featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'captain_assistants_guidelines_index',
    meta: {
      ...captainMeta('captain_settings'),
      featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
    },
  },
  {
    path: frontendURL('accounts/:accountId/captain/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'captain_assistants_create_index',
    meta: captainMeta(...CAPTAIN_PAGE_PERMISSIONS),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'captain_assistants_index',
    meta: captainMeta(...CAPTAIN_PAGE_PERMISSIONS),
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/captain'),
    component: CaptainPageRouteView,
    redirect: to => {
      return {
        name: 'captain_assistants_index',
        params: {
          navigationPath: 'captain_assistants_overview_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
